import ObraLocalizacao from "./obra-localizacao";

export default class Obra {
    constructor();
    constructor(proxy: any)
    constructor(proxy?: any) {
        if (proxy != null) {
            for(const key in this){
              if(proxy[key] != null && (typeof this[key] == typeof proxy[key])){
                this[key] = proxy[key];
              }
            }
        }
    }

    public codLote: number = 0;
    public codProjeto: number = 0;
    public localizacoes: Array<ObraLocalizacao> = new Array<ObraLocalizacao>;
    public processo: string = '';
    public endereco: string = '';
    public situacao: string = '';
    public situacaoLote: string = '';
    public situacaoLicitacao: string = '';
    public situacaoContrato: string = '';
    public situacaoHexKey: string = '';
    public descLote: string = '';
    public numProcesso: string = '';
    public valorAtual: number = 0;
    public valorExecutado: number | null = null;
    public codContrato: number | null = null;
    public numContrato: string = '';
    public porcentagemExecutada: string = '';
    public siglaDepartamento: string = '';
    public descDepartamento: string = '';
    public status: string = '';
    public statusColor: string = '';
    public favorito: boolean = false;
}